import { render, staticRenderFns } from "./PenarikanSaldoPenelitiKeamanan.vue?vue&type=template&id=4405ce5d&scoped=true&"
import script from "./PenarikanSaldoPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./PenarikanSaldoPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405ce5d",
  null
  
)

export default component.exports